var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCricket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.914 6.536a2 2 0 000 2.828l7.071 7.071a2 2 0 002.829 0l.353-.354 2.829 2.829a1 1 0 001.414-1.414l-2.829-2.829.354-.353a2 2 0 000-2.829l-7.071-7.07a2 2 0 00-2.828 0l-2.122 2.12zm9.546 7.424l1.06-1.06-7.07-7.072L6.328 7.95l7.071 7.07 1.061-1.06z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#141414"
  })));
}
export default SvgCricket;